<template>
  <Page title="Dashboard">
    <div style="display:flex; max-width: 300vw;">
      <div style="flex:1.2; padding:0 10px; max-width: 100vw;">
        <last-activities></last-activities>
      </div>
      <div style="flex:1.5; max-width: 100vw;">
        <div class="themic">
          <div class="--header">
            <div
              style="font-size:14px; line-height:29px; padding: 4px 10px 12px 10px;"
            >
              Ringkasan Potensi
            </div>
          </div>
          <potensi-summary
            :params="ringkasanParams"
            style="background:white; height:calc(100vh - 160px); overflow:auto;"
            class="--body"
          />
        </div>
      </div>
      <div style="flex:1; max-width: 100vw;">
        <chart-per-balai />
      </div>
    </div>
  </Page>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import ChartPerBalai from './ChartPerBalai.vue'
import PotensiSummary from '../Asset/Asset/PotensiSummary.vue'
import LastActivities from './LastActivities.vue'

export default {
  name: 'Home',
  components: {
    ChartPerBalai,
    PotensiSummary,
    LastActivities,
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
    }),
    ringkasanParams() {
      return { AssetId: 0, PotensiId: 0, BalaiId: this.user.CityID }
    },
  },
  mounted() {},
}
</script>
<style lang="scss">
.hide {
  display: none;
}
</style>
